import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPut } from "../api/client";

// ── Teams webhook ─────────────────────────────────────────────────────────────

interface TeamsWebhook {
  webhook_url: string | null;
}

export function useTeamsWebhook(workspaceId: string) {
  return useQuery<TeamsWebhook, Error>({
    queryKey: ["teams-webhook", workspaceId],
    enabled: Boolean(workspaceId),
    queryFn: () => apiGet<TeamsWebhook>(`/api/workspaces/${workspaceId}/teams-webhook`),
    staleTime: 60_000,
  });
}

export function useUpdateTeamsWebhook(workspaceId: string) {
  const qc = useQueryClient();
  return useMutation<{ ok: boolean }, Error, string>({
    mutationFn: (webhook_url: string) =>
      apiPut<{ ok: boolean }>(`/api/workspaces/${workspaceId}/teams-webhook`, { webhook_url }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["teams-webhook", workspaceId] });
    },
  });
}
